import * as routes from "utils/contants/urls";

import {
  ActionItem,
  Actions,
  Label,
  LabelAction,
  LabelHeader,
  Table,
  TableBody,
  TableColumn,
  TableHead,
  TableRow,
} from "components/shared/CustomComponentsStyle";
import * as urls from "utils/contants/urls";
import { push } from "connected-react-router";
import React, { useEffect, useState } from "react";
import { Creators as messageAction } from "store/ducks/messages";
import { Col, Row } from "react-bootstrap";
import { view } from "assets/icons/icons";
import { StatusDocuments, TipoContrato } from "utils/contants/enums";
import { Body } from "./ManagerCandidatesContractStyle";
import BreadCrumb from "components/Layout/breadcrumb";

import {
  SelectFieldInput,
  CheckBox,
  ButtonDefault,
  ButtonSecondary,
  MultSelectCreatable,
} from "components/shared/CustomInputs";

import ButtonUpload from "components/ButtonUpload";

import { FormattedMessage } from "react-intl";
import Load from "components/Layout/Load";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Creators as contractsAction } from "store/ducks/contracts";

import { YesOrNoWithTextDialog } from "components/shared/CustomComponents";

const ManagerCandidatesContract = ({
  filesCandidateSelected,
  isLoading,
  location,
  messagePublication,
  requestTypeContracts,
  inviteCandidates,
  changeContractRequest,
  tipoContratoList,
  log,
}) => {
  const [showDialogYesOrNo, setShowDialogYesOrNo] = useState(0);
  const [formValues, setFormValues] = useState({ cpfs: [], tipoContrato: "" });
  const [erroMessage, setErroMessage] = useState({ message: "" });
  const [logProcess, setlogProcess] = useState([]);
  const token = localStorage.getItem("Authorization");

  useEffect(() => {
    isLoading = false;
    requestTypeContracts();
  }, []);

  useEffect(() => {
    setlogProcess(log);
  }, [log]);

  const includeNewContract = () => {
    inviteCandidates({
      cpfs: formValues.cpfs,
      tipoContrato: formValues.tipoContrato,
    });
  };

  const changeContract = (e, idCandidateEmEtapa) => {
    changeContractRequest({ file: e, idCandidateEmEtapa: idCandidateEmEtapa });
    e = null;
  };

  const canShowDialog = (idDoc) => {
    return showDialogYesOrNo == idDoc;
  };

  const setColorStatus = (status) => {
    switch (status) {
      case 2:
        return { fontWeight: "bold", color: "#d01616" };
      case 3:
        return { fontWeight: "bold", color: "#32a34c" };
      default:
        return {};
    }
  };

  const [exibirReprovados, setExibirReprovados] = useState(false);

  const TrataMultiInsert = (Insert) => {
    setErroMessage({ message: "" });
    let messages = [];
    let result = [];
    Insert.map((item) => {
      let conc = item.value.split(/[\s,]+/);
      conc.map((filtItem) => {
        if (filtItem.length == 11) {
          result.push(filtItem);
        } else {
          messages.push({
            message:
              `cpf ${filtItem} com menos de 11 digitos.Não será considerado no filtro.`,
            type: "warning",
          });
        }
      });
    });
    messagePublication(messages);
    return result;
  };

  const renderFilesCandidatesTable = (items) => {
    return (
      <div>
        <Table>
          <TableBody>
            <TableRow noBorder>
              <TableHead ta="left" style={{ width: "50%" }}>
                <LabelHeader>Cpf</LabelHeader>
              </TableHead>
              <TableHead ta="center">
                <LabelHeader>Detalhes</LabelHeader>
              </TableHead>
              <TableHead ta="center">
                <LabelHeader>Status do processo</LabelHeader>
              </TableHead>
            </TableRow>
            {items && renderTableFilesItems(items)}
          </TableBody>
        </Table>
      </div>
    );
  };
  const renderTableFilesItems = (items) =>
    items.map((log) => (
      <TableRow>
        <TableColumn ta="left">
          <Label>{log.cpf}</Label>
        </TableColumn>
        <TableColumn ta="center">
          <Label>{log.descricao}</Label>
        </TableColumn>
        <TableColumn ta="center">
          <Label>{log.status}</Label>
        </TableColumn>
      </TableRow>
    ));

  if (isLoading) return <Load isLoading={isLoading} />;
  return (
    <React.Fragment>
      <h3 style={{ color: "#19b3d2" }}>
        {" "}
        Liberar assinaturas de contratos e termos
      </h3>

      <Body>
        <MultSelectCreatable
          key={5}
          name={<FormattedMessage id="documentsCandidateList.filterCpf" />}
          label={<FormattedMessage id="documentsCandidateList.filterCpf" />}
          isMulti
          options={formValues.cpfs}
          value={
            formValues.cpfs
              ? formValues.cpfs.map((e) => ({
                  label: e,
                  value: e,
                }))
              : []
          }
          onChange={(e) =>
            setFormValues({
              ...formValues,
              cpfs: e ? TrataMultiInsert(e) : [],
            })
          }
        />

        <Row>
          <Col md={4}>
            <SelectFieldInput
              onChange={(e) =>
                setFormValues({ ...formValues, tipoContrato: e.target.value })
              }
              value={formValues.tipoContrato}
              items={tipoContratoList}
              width="100%"
            />
          </Col>

          <Col md={4}>
            <ButtonDefault
              name={"Liberar"}
              disabled={
                formValues.cpfs.length == 0 || formValues.tipoContrato == ""
              }
              mr="18px"
              isLoading={isLoading}
              onClick={() => includeNewContract()}
             />
          </Col>
        </Row>

        {renderFilesCandidatesTable(logProcess)}
      </Body>
    </React.Fragment>
  );
};
const mapDispatchToProps = (dispatch) => ({
  inviteCandidates: (payload) =>
    dispatch(contractsAction.candidateIncludeNewContractRequest(payload)),
  messagePublication: (messages) =>
    dispatch(messageAction.messagePublication(messages)),
  requestTypeContracts: (payload) =>
    dispatch(contractsAction.typeContractsRequest()),
});
const mapStateToProps = (state) => {
  return {
    tipoContratoList: state.contracts.tipoContratoList,
    filesCandidateSelected: state.documents.candidatesFiles,
    log: state.contracts.logProcess,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManagerCandidatesContract);

ManagerCandidatesContract.propTypes = {
  filesCandidateSelected: PropTypes.func,
};

ManagerCandidatesContract.defaultProps = {
  candidates: () => {},
  filesCandidateSelected: () => {},
};
